import { render, staticRenderFns } from "./dailyRegistration.vue?vue&type=template&id=073d6ab4&scoped=true&"
import script from "./dailyRegistration.vue?vue&type=script&lang=js&"
export * from "./dailyRegistration.vue?vue&type=script&lang=js&"
import style0 from "./dailyRegistration.vue?vue&type=style&index=0&id=073d6ab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073d6ab4",
  null
  
)

export default component.exports